import {media} from '@wix/sdk';

export class ImageModel {
  public url: string;
  public width: number;
  public height: number;
  public id?: string;

  constructor(params: ImageModel) {
    this.url = params?.url;
    this.width = params?.width;
    this.height = params?.height;
    this.id = params?.id;
  }

  public static fromSDK(imageUrl: string) {
    const image = media.getImageUrl(imageUrl);
    return new ImageModel({
      url: image.filename,
      width: image?.width,
      height: image?.height,
      id: image?.id,
    });
  }
}
